import React from 'react';
import { Icon } from 'semantic-ui-react';
import _ from 'lodash';
import './dc.css';

export const tbodyFunction = (
  selectedDocsYes,
  numberofpagesbydoctype,
  state,
  docTypes_zb,
  toggleDocumentType,
  selectdocumentType,
  shipmentCountry,
  hasTheseDocsForThisType,
  canSelectIndividualPages,doctips,
  selectedKxShipmentId
) => {

//   function filterObjectsByKeys(numberofpagesbydoctype, arrayOfObjects) {
//     const filteredObject = {};

//     for (const key in numberofpagesbydoctype) {
//         if (numberofpagesbydoctype.hasOwnProperty(key)) {
//             const filteredItem = arrayOfObjects.find(obj => obj.id+" "+"-"+" "+obj.value === key);
//             if (filteredItem) {
//                 filteredObject[key] = numberofpagesbydoctype[key];
//             }
//         }
//     }
//     return filteredObject;
// }

  return Object.keys(numberofpagesbydoctype)
    .sort((a, b) => {
      if (!selectedDocsYes) {
        if(a=="OBSOLETE")return 1;
        if(b=="OBSOLETE")return -1;
        a.localeCompare(b); //sort alphabetically for unselected docs
      }
      let aindex =
        state.selectedDocuments_lo.indexOf(a) >= 0
          ? state.selectedDocuments_lo.indexOf(a)
          : -99999;
      let bindex =
        state.selectedDocuments_lo.indexOf(b) >= 0
          ? state.selectedDocuments_lo.indexOf(b)
          : -99999;
      return aindex - bindex; //sort based on when things were added to the list
    })
    .map((onedoccname, iiiil) => {
      if (onedoccname + '' == 'undefined') return false;
      let longLabelForMe = onedoccname;
      let myDocType = (docTypes_zb || []).filter((a) => a.name == onedoccname);
      if (myDocType.length) {
        myDocType = myDocType[0];
        longLabelForMe = myDocType.longLabel;
      }
      let documentNumber =
        state.selectedDocuments_lo.indexOf(onedoccname) >= 0
          ? 1 + state.selectedDocuments_lo.indexOf(onedoccname)
          : '';
      if (selectedDocsYes && !documentNumber)
        return (
          <React.Fragment
            key={onedoccname + documentNumber + 'foomagic' + selectedDocsYes}
          ></React.Fragment>
        );
      return (
        <tr
          key={onedoccname + documentNumber + 'foomagic' + selectedDocsYes}
          className={onedoccname == state.selectedDocType ? ' selected ' : ''}
          style={documentNumber && !selectedDocsYes ? { opacity: 0.05 } : {}}
        >
          <td style={{ cursor: 'pointer' }}>{documentNumber}</td>
          <td>
            <input
              onChange={() => {
                toggleDocumentType(onedoccname);
              }}
              type='checkbox'
              checked={
                state.selectedDocuments_lo.indexOf(onedoccname) >= 0
                  ? 'checked'
                  : false
              }
            />
          </td>
          <td
            onClick={() => {
              selectdocumentType(onedoccname, shipmentCountry);
            }}
          >
            {longLabelForMe}
            <div className='selectbuttonnn'>Preview</div>
          </td>
          <td
            onClick={() => {
              selectdocumentType(onedoccname, shipmentCountry);
            }}
          >
            {canSelectIndividualPages && <>
            {(hasTheseDocsForThisType(onedoccname, false, selectedKxShipmentId)?.length == numberofpagesbydoctype[onedoccname].length)?"":<>
                    {hasTheseDocsForThisType(onedoccname, false, selectedKxShipmentId)?.length}/
                  </>}
            </>}
            {numberofpagesbydoctype[onedoccname]} Page{numberofpagesbydoctype[onedoccname]!=1?"s":""}
          </td>
          {shipmentCountry == 'CA' && (
            <td
              onClick={() => {
                alert('123');
                selectdocumentType(onedoccname, shipmentCountry);
              }}
            >
              {state.listOfSelectedDocuments.includes(onedoccname) ? (
                <Icon name='check' title='Form is ready' />
              ) : state.selectedDocuments_lo.indexOf(onedoccname) >= 0 ? (
                <Icon
                  name='exclamation'
                  color='red'
                  title='Form is unworked!'
                />
              ) : (
                <></>
              )}
            </td>
          )}
          {state.documentStatusList_ka.length > 0 && (
            <td
              onClick={() => selectdocumentType(onedoccname, shipmentCountry)}
            >
              {state.documentStatusList_ka.map((onedocStatusObj, iiii) => {
                if (onedocStatusObj.docType != onedoccname) return null;
                return (
                  <div title={onedocStatusObj.responseMsg}>
                    {!onedocStatusObj.statusCode ||
                    onedocStatusObj.statusCode != 200
                      ? 'Failed'
                      : 'Success'}
                  </div>
                );
              })}
            </td>
          )}
        </tr>
      );
    });
};


  export const hasTheseDocsForThisType = (docType, showUnusedDocs, selectedKxShipmentId, state) => {
    let dontUseTheseDocIds=  state.dontUseTheseDocIds || {};
    let allDocsForThisType = (state.doclistttt||{})[selectedKxShipmentId]
      .filter((a) => {
        if (docType != "use__id") {
          if(!docType){//If no doctype param, select all documents within selected document types
            return (state.selectedDocuments_lo||[]).includes(a.documentType);
          }
          return (//If doctype param, select all documents within a specific document type
            a.documentType == docType
          );
        } else {//Show just a specifici docid
          return a.docid == state.selectedDocId_p;
        }
      })
    if(showUnusedDocs)return allDocsForThisType;//Don't filter by the ignore document feature
    return allDocsForThisType.filter(a => !dontUseTheseDocIds[a.docid]);//Filter by the ignore document feature
  }